import { 
    CreateBirthdayRewardSettingDto, 
    DeleteBirthdayRewardSettingDto,
    EditBirthdayRewardSettingDto,
    GetBirthdayRewardSettingDto, 
    MessageResponseDto, 
    UtilBirthdayRewardSettingControllerGet200Response,
    UtilityBirthdayRewardSettingApiFp,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseBirthdayRewardModel = UtilBirthdayRewardSettingControllerGet200Response;
export type GetBirthdayRewardModel = GetBirthdayRewardSettingDto;
export type MutateResponseBirthdayRewardModel = MessageResponseDto;
export type CreateBirthdayRewardModel = CreateBirthdayRewardSettingDto;
export type UpdateBirthdayRewardModel = EditBirthdayRewardSettingDto;
export type DeleteBirthdayRewardModel = DeleteBirthdayRewardSettingDto;

export const apiBirthdayRewardFp =  UtilityBirthdayRewardSettingApiFp(apiConfig);
export const getBirthdayRewardController = apiBirthdayRewardFp.utilBirthdayRewardSettingControllerGet;
export const createBirthdayRewardController = apiBirthdayRewardFp.utilBirthdayRewardSettingControllerCreate;
export const updateBirthdayRewardController = apiBirthdayRewardFp.utilBirthdayRewardSettingControllerEdit;
export const deleteBirthdayRewardController = apiBirthdayRewardFp.utilBirthdayRewardSettingControllerDelete;

export const QueryKeyBirthdayReward = QueryKey.BirthdayReward;